export default "__VITE_ASSET__BfUBN4PJ__"